
/********** API 配置 ****************/
export const HOST = `${window.location.protocol}//${window.location.host}`;

export const TOKEN_KEY = "cym-wechat-token";
export const WECHAT_CODE_KEY = "wechat-code";
export const API_DOMAIN =  process.env.VUE_APP_API_DOMAIN;
export const IMAGE_DOMAIN = "http://cym.bestweixiao.com";

/********* 微信配置 ************/
export const AUTHOR_URL = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=SCOPE&state=STATE#wechat_redirect';
export const WE_CHAT_APP_ID = process.env.VUE_APP_WE_CHAT_APP_ID;
